import React, { useEffect, useRef, useState } from "react";
import classes from "./Clock.module.css";

export default function Clock({ time }) {
  const [milliSeconds, setMilliSeconds] = useState(1500000);
  const [isCountDown, setIsCountDown] = useState(false);
  const [isAction, setIsAction] = useState(false);
  const curTime = new Date(milliSeconds);
  const count = useRef();

  useEffect(() => {
    count.current = setInterval(() => {
      if (isCountDown || isAction) {
        setMilliSeconds((prev) => prev - 1000);
      }
      if (!isCountDown || isAction) {
        clearInterval(count.current);
      }
      if (milliSeconds === 0) {
        clearInterval(count.current);
        alert("時間到囉～記得休息一下！");
        setMilliSeconds(1500000);
      }
    }, 1000);
    setIsAction(false);

    return () => {
      clearInterval(count.current);
    };
  }, [isCountDown, milliSeconds, isAction]);

  const startCountDown = () => {
    setIsCountDown(true);
    setIsAction(true);
  };
  const stopCountDown = () => {
    setIsCountDown(false);
    setIsAction(true);
  };
  const resetCountDown = () => {
    setIsCountDown(false);
    setIsAction(true);
    setMilliSeconds(1500000);
  };

  return (
    <div>
      <h1 className={classes.clock}>
        {curTime.getMinutes() < 10 ? 0 : null}
        {curTime.getMinutes()}:{curTime.getSeconds() < 10 ? 0 : null}
        {curTime.getSeconds()}
      </h1>

      {!isCountDown && (
        <div
          className={classes.button}
          style={{ backgroundColor: "#D05151" }}
          onClick={startCountDown}
        >
          開始
        </div>
      )}

      {isCountDown && (
        <div
          className={classes.button}
          style={{ backgroundColor: "#8A5151" }}
          onClick={stopCountDown}
        >
          停止
        </div>
      )}

      <div
        className={classes.button}
        style={{ backgroundColor: "#5F2B2B" }}
        onClick={resetCountDown}
      >
        重新計算
      </div>
    </div>
  );
}
